'use strict'

/**
 * Project easytitle24 app
 * Created by hielo on 2018-06-09
 */

import checkout from './checkout.vue'
import receipt from './receipt.vue'

const routes = [
	{
		path: '/checkout/:projId/:isNewHome/:error?',
		name: 'checkout',
		component: checkout,
		props: true,
		meta: { authRequired: true }
	},
	{
		path: '/checkout/receipt',
		name: 'checkout.receipt',
		component: receipt,
		props: true,
		meta: { authRequired: true }
	}
]

export default routes



// WEBPACK FOOTER //
// ./src/app/checkout/index.js